import { render, staticRenderFns } from "./WishlistSidebarContent.vue?vue&type=template&id=3bc0ee89&scoped=true&"
import script from "./WishlistSidebarContent.vue?vue&type=script&lang=js&"
export * from "./WishlistSidebarContent.vue?vue&type=script&lang=js&"
import style0 from "./WishlistSidebarContent.vue?vue&type=style&index=0&id=3bc0ee89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc0ee89",
  null
  
)

export default component.exports